import React from 'react';
import $ from "jquery";
import Server from '../../functions/server';
import Loading from '../loading';
import Info from '@material-ui/icons/Info';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Grid } from '@material-ui/core';
import SpareDetails from '../PurchaseAndStock/PurchaseDetails/sparedetails';

class SparesInfo extends React.Component {

  state = {
    sparesDetails: [], branchStocks: []
  }

  getSparesInfo() {
    let context = this;
    $.ajax({ type: 'POST', data: { 'partno': context.props.partno, 'brand': context.props.brand },
      url: Server() + 'purchasedetail/getSparesInfo.php',
      success: function(data) {
        console.log(data);
        let hsncode = 0;
        let mrp = 0;
        let branchStocks = [];
        try {
          data = JSON.parse(data);
          data.map((c) => {
            hsncode = c.hsncode;
            mrp = c.mrp;
            branchStocks = c.branch_stocks;
          })
          context.setState({ branchStocks, hsncode, mrp, open: true })
        } catch (error) {
          
        }
      },
      error: function(err) {
        console.log(err);
        context.setState({ load: false, });
      }
    })
    
  }

  render() {
    return (
      <div>
          <Info onClick={this.getSparesInfo.bind(this)} style={{fontSize: 22, cursor: 'pointer'}} />
          <Dialog open={this.state.open} onClose={ () => { this.setState({ open: false }) }}
            aria-labelledby="responsive-dialog-title" >
            <DialogTitle id="responsive-dialog-title" style={{width: 600}}>
              {"Spares Details"}
            </DialogTitle>
            <DialogContent>
              <Grid container spacing={3}>
                <Grid item xs={3}>
                  <b>Partno</b><br/>
                  {this.props.partno}
                </Grid>
                <Grid item xs={3}>
                  <b>MRP</b><br/>
                  {this.state.mrp}
                </Grid>
                <Grid item xs={3}>
                  <b>HSN CODE</b><br/>
                  {this.state.hsncode}
                </Grid>
                <Grid item xs={3}>
                  <SpareDetails partno={this.props.partno} />
                </Grid>
                <Grid item xs={12}>
                  <br/>
                  <b>Other Branch Stocks</b>
                  <table id="table" width="100%">
                    <tr id='th'>
                      <th id='th'>Branch</th>
                      <th id='th'>Brand</th>
                      <th id='th'>Stocks</th>
                      <th id='th'>Min_Qty</th>
                    </tr>
                    {
                      this.state.branchStocks.map((c) => {
                        return (
                          <tr>
                            <td>{c.branch_name}</td>
                            <td>{c.brand_name}</td>
                            <td>{c.stock}</td>
                            <td>{c.min_stock}</td>
                          </tr>
                        )
                      })
                    }
                  </table>
                </Grid>
              </Grid>
            </DialogContent>
          </Dialog>
      </div>
    );
  }
}

export default SparesInfo;
